<div class="achievement">

  <header class="achievement__header">

    <!-- The root-filter component handles his own visibility (depending on brand, route, etc.) -->
    <app-root-filter class="achievement__root-filter"></app-root-filter>

    @if (!isNewUser && showTabHeader) {
      <nav
        class="achievement__tab-nav"
        mat-tab-nav-bar>
        @for (link of navLinksToApply(); track link) {
          <a
            class="achievement__tab-nav-link"
            mat-tab-link
            #rla="routerLinkActive"
            [active]="rla.isActive"
            [routerLink]="link.path"
            routerLinkActive
            appAriaTitle>
            {{ link.keyTranslate | translate }}
          </a>
        }
      </nav>
    }

  </header>

  <main class="achievement__main">

    <router-outlet></router-outlet>

  </main>

</div>